export const checkFormDirty = (currentState, initialState) => {
    for (const fieldItem of currentState) {
        const fieldName = fieldItem.name[0];
        let fieldValue = fieldItem.value;
        let initialFieldValue = initialState[fieldName];

        if ((!initialFieldValue && typeof initialFieldValue !== 'number') ||
            (Array.isArray(initialFieldValue) && !initialFieldValue.length)
            || initialFieldValue === '<p><br></p>') {
            initialFieldValue = '';
        }
        if ((!fieldValue && typeof fieldValue !== 'number')
            || (Array.isArray(fieldValue) && !fieldValue.length)
            || fieldValue === '<p><br></p>') {
            fieldValue = '';
        }
        if (initialFieldValue.toString() !== fieldValue.toString()) {
            return true;
        }
    }

    return false;
};

export const arraysEqual = (arrOne, arrTwo) => {
    if (arrOne.length !== arrTwo.length) return false;

    let sortedArrOne = arrOne.slice().sort();
    let sortedArrTwo = arrTwo.slice().sort();

    for (let i = 0; i < sortedArrOne.length; i++) {
        if (sortedArrOne[i] !== sortedArrTwo[i]) return false;
    }
    return true;
}

export const validatePass = pw => {
    return /[A-Z]/.test(pw) &&
        /[a-z]/.test(pw) &&
        /[0-9]/.test(pw) &&
        /[!"#$%&'()*+,-.\/:;<=>?@[\]^_`{|}~]/.test(pw) &&
        pw.length > 8;
}

export const getAccountStatus = (organization, intl) => {
    let accountStatus = intl.formatMessage({id: 'active_label'});
    const plan = organization.subscription?.plan;
    if (plan?.monetaryType === 'FREE_TRIAL' && organization.subscription?.status === 'CANCELLED') {
        accountStatus = intl.formatMessage({id: 'expired_label'});
    } else if (plan?.monetaryType === 'FREE_TRIAL') {
        accountStatus = intl.formatMessage({id: 'trial_label'});
    }

    return accountStatus;
};

export const formatDate = (date) => {
    const tokens = date.split('T')[0].split('-');

    return tokens[2] + '.' + tokens[1] + '.' + tokens[0];
};
